import type { MDSAliases } from './getMdsUrl';

/** Пороги для выбора алиаса превью в сетке */
const ALIAS_THRESHOLDS: { maxEffectiveWidth: number; alias: MDSAliases }[] = [
    { maxEffectiveWidth: 280, alias: 's' },
    { maxEffectiveWidth: 480, alias: 'm' },
    { maxEffectiveWidth: 720, alias: 'l' },
    { maxEffectiveWidth: Infinity, alias: 'xl' },
];

export function getGridImageAlias(cardWidth: number, dpr: number = 1): MDSAliases {
    const effectiveWidth = cardWidth * dpr;

    for (const { maxEffectiveWidth, alias } of ALIAS_THRESHOLDS) {
        if (effectiveWidth <= maxEffectiveWidth) {
            return alias;
        }
    }

    return 'xl';
}

/** Алиас для мелких превью (коллекции, списки) */
export function getCompactImageAlias(cardWidth: number, dpr: number = 1): MDSAliases {
    const effectiveWidth = cardWidth * dpr;

    if (effectiveWidth <= 180) {
        return 's';
    }

    if (effectiveWidth <= 400) {
        return 'm';
    }

    return 'l';
}
